import type { SettingsSection } from '#contract'
import { text } from '#contract'
import { useClient } from '../../app/client-context.ts'
import { Button } from '../../components/button.tsx'
import { useT } from '../../i18n/index.ts'
import styles from './settings-screen.module.css'

/** Restores one settings group to the defaults for this device. */
export function ResetSection({ section }: { readonly section: SettingsSection }) {
  const t = useT()
  const client = useClient()
  return (
    <div class={styles.reset}>
      <Button
        variant="ghost"
        onClick={() => {
          client?.resetSettings(section)
        }}
      >
        {t(text('settings.reset'))}
      </Button>
    </div>
  )
}
